"use strict";
import t from "./index.es110.js";
function f(u, e, s) {
  const a = s.config.validateStatus;
  !s.status || !a || a(s.status) ? u(s) : e(new t(
    "Request failed with status code " + s.status,
    [t.ERR_BAD_REQUEST, t.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
    s.config,
    s.request,
    s
  ));
}
export {
  f as default
};
//# sourceMappingURL=index.es174.js.map
